export default "__VITE_ASSET__iWALUJ1M__"